<template>
  <div class="default-bg quiz">
    <Header bg_image="topbanner_quiz.png"></Header>

    <div class="content">
      <span class="title" v-html="questions[id]"></span>
      <div :class="[index == selected ? 'answer-button active' : 'answer-button']" v-for="(answer, index) in answers[id]" :key="index" @click="answerQuestion(index + 1)">{{answer}}</div>

      <button :class="nextBtnClass" @click="nextQuestion">下一題</button>
    </div>

    <Footer bg_image="botbanner_quiz.png"></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: "quiz",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      selected: null,
      nextBtnClass: '',
      questions: [
        '平常最喜歡去哪裡放鬆',
        '如果擁有一天交換身份的機會<br>最想體驗哪個角色',
        '想要擁有什麼超能力'
      ],
      answers: [
        ['酒吧派對狂歡一整晚',  '窩在藝術博物館一整天', '盡情吃甜點午茶享樂', '沈浸大自然變成一棵樹'],
        ['舞台上的耀眼明星',  '品味生活的藝術家', '森林裡的植物研究學家', '旅行世界的冒險家'],
        ['過目不忘的超強記憶力',  '看穿他人心事的能力', '能聽得懂動物說的話', '不需要睡眠、擁有比別人更多的時間']
      ]
    }
  },
  computed: {
    id() {
      return parseInt(this.$route.params.id) - 1; 
    }
  },
  methods: {
    answerQuestion(idx) {
      this.selected = idx - 1
      this.nextBtnClass = 'show'

      if (this.id <= 2) {
        this.$store.commit('setAnswer', {
          idx: this.id + 1,
          answer: idx
        })
      }
    },
    nextQuestion() {
      if (this.id + 2 < 4) {
        this.$router.push({
          name: 'quiz',
          params: {
            id: this.id + 2
          }
        })
      } else {
        this.$router.push({
          name: 'result'
        })
      }
      this.selected = null;
      this.nextBtnClass = ''
    }
  }
  // $route.query.q
}
</script>

<style lang="scss">
  @keyframes slideHeader {
    from { top: -300px; }
    to { top: 0; }
  }
  @keyframes slideFooter {
    from { bottom: -200px; }
    to { bottom: 0; }
  }
  .quiz {
    .header {
      animation: slideHeader 2s;
    }
    .footer {
      animation: slideFooter 2s;
    }
    .content {
      animation: fadeInContent 4s;
      .title {
        padding-top: 70px;
        white-space: pre-wrap; 
        word-wrap: break-word;
        font-size: 1.7rem;
        line-height: 2.3rem;

        text-decoration: underline;

        margin-bottom: 20px;
      }
      .answer-button {
        width: 80%;
        max-width: 500px;
        padding: 7px 0;
        margin: 5px auto;
        border: 2px solid #979797;
        border-radius: 15px;
        transition: 0.5s;

        cursor: pointer;

        &:hover, &.active {
          background-color: #B83A48;
          color: #fff;
          border-color: #B83A48;
        }
      }

      button {
        margin: 0 auto;
        margin-top: 30px;
        width: 100px;
        font-size: 1.1rem;
        margin-top: 25px;
        color: #fff;
        background-color: #666666;
        border: 1px solid #666;

        opacity: 0;
        transition: 0s;

        cursor: pointer;

        &.show {
          opacity: 1;
          transition: 2s;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .quiz {
      .content {
        .title { 
          font-size: 1.6rem;
          padding-top: 50px;
        }
      }
    }
  }
  @media screen and (max-width: 330px) {
    .quiz {
      .content {
        .title { 
          font-size: 1.4rem;
          padding-top: 45px;
        }
        .answer-button {
          font-size: .9rem;
        }
      }
    }
  }
</style>